// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import './BlogList.css'; // Make sure you style this file

// const SellList = () => {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const fetchBlogs = async () => {
//     const res = await axios.get('/api/Sells');
//     setBlogs(res.data);
//   };

//   return (
//     <div>
//       <div className="sapfincon-wrapper">
//   <div className="background-animation">
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//   </div>
//          <div
//   className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
//   style={{ marginBottom: '90px',width: "120vw", position: "relative",left: "-10vw"}}
// >
//   <div
//     className="container text-center py-5 px-0"
//     style={{ marginTop: "-80px" }}
//   >
//     <h1 className="text-white display-1">Products</h1>
//     <div className="d-inline-flex text-white mb-5">
//       <p className="m-0 text-uppercase">
//         <a className="text-white" href="">Home</a>
//       </p>
//       <i className="fa fa-angle-double-right pt-1 px-3"></i>
//       <p className="m-0 text-uppercase">Products</p>
//     </div>

//     <div className="w-100 mb-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
  
//     </div>
//   </div>
// </div>
//    <div className="blog-grid">
      
//       {blogs.map(blog => (
//         <div key={blog._id} className="blog-card">
//           <img
//             src={`/uploads/${blog.imagePath}`}
//             alt="blog"
//           />
//           <h3>{blog.title}</h3>
//           <p>{blog.caption}</p>
//           <Link
//             to="/SellDetail"
//             state={{ id: blog._id }}
//             className="read-more-button"
//           >
//             Read More →
//           </Link>
//         </div>
//       ))}
//     </div>
   

//     </div></div>
//   );
// };

// export default SellList;
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './BlogList.css'; // Your CSS for the grid & cards

const SellList = () => {
  const [sells, setSells] = useState([]);

  useEffect(() => {
    fetchSells();
  }, []);

  const fetchSells = async () => {
    try {
      const res = await axios.get('/api/Sells');
      setSells(res.data);
    } catch (error) {
      console.error('Failed to fetch sells:', error);
    }
  };

  return (
    <div className="sell-page">
      {/* Page Header */}
      <div className="page-header-wrapper">
        <div className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom">
          <div className="container text-center py-5">
            <h1 className="text-white display-1">Products</h1>
            <div className="d-inline-flex text-white mb-5">
              <p className="m-0 text-uppercase">
                <a className="text-white" href="/">Home</a>
              </p>
              <i className="fa fa-angle-double-right pt-1 px-3"></i>
              <p className="m-0 text-uppercase">Products</p>
            </div>
          </div>
        </div>
      </div>

      {/* Products Grid */}
      <div className="blog-grid">
        {sells.map(sell => (
          <div key={sell._id} className="blog-card">
            {sell.imagePath && (
              <img
                src={`/uploads/${sell.imagePath}`}
                alt={sell.title}
              />
            )}
            <h3>{sell.title}</h3>
            <p>{sell.caption}</p>
            <Link
              to="/SellDetail"
              state={{ id: sell._id }}
              className="read-more-button"
            >
              Read More →
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SellList;
